import { CTA, CTAProps } from '@/components/CTA';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';

import styles from './ParagraphContent.module.scss';

export interface ParagraphContentProps {
  title?: string;
  /**
   * Plain text content for the body. Use this OR bodyRichText, not both.
   */
  bodyPlainText?: string;
  /**
   * Rich text converted to HTML on the server side
   */
  bodyRichTextAsHTML?: string;
  cta?: CTAProps;
  showDivider?: boolean;
}

export const ParagraphContent: React.FC<ParagraphContentProps> = ({
  title,
  bodyPlainText,
  bodyRichTextAsHTML,
  cta,
  showDivider = false,
}) => {
  const renderBody = () => {
    if (bodyRichTextAsHTML) {
      return (
        <div
          className={styles.body_rich_text}
          dangerouslySetInnerHTML={{ __html: bodyRichTextAsHTML }}
          suppressHydrationWarning={true}
        />
      );
    }

    return (
      <Typography as="p" className={styles.body_plain_text}>
        {bodyPlainText}
      </Typography>
    );
  };

  return (
    <div className={styles.paragraph_container}>
      <div className={styles.content}>
        {title && (
          <Typography as="h3" className={styles.title}>
            
          </Typography>
        )}
        {renderBody()}
      </div>
      {cta && <CTA label={cta.label} link={cta.link} type={cta.type} dataHeapId={cta.dataHeapId} />}
      {showDivider && <hr className={styles.divider} />}
    </div>
  );
};
